export default {
  total: 'total',
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json; charset=utf-8',
  },
  updateMethod: 'PATCH',
};
